// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-box {
  height: 180px; /* Set fixed height */
  background-color: #ffffff; /* White background */
  border: 1px solid #ddd; /* Light grey border */
  border-radius: 8px; /* Rounded corners */
  padding: 8px;
  overflow: hidden;
}

.image-box img {
  width: 100%; /* Make sure the image fits the container */
  height: 100%; /* Maintain the height */
  object-fit: cover; /* Ensure image covers the container without distortion */
  border-radius: 4px;
}

/* ============================================================
   CATEGORY COLLAPSE
   ============================================================ */
.category-collapse {
  position: relative;
  border-radius: var(--radius, 8px);
  overflow: hidden;
  min-width: 0;
  /* Keep original component background */
  background: inherit;
  transition: box-shadow 150ms ease, transform 150ms ease;
}

/* ============================================================
   LEFT BLUE ACCENT
   ============================================================ */
.category-collapse::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 6px;
  background: #88b6f2;
  /* Hardcoded fallback radius so the curve is ALWAYS visible,
     even if --radius is 0/undefined in this scope */
  border-radius: 10px 0 0 10px;
  z-index: 2;
  pointer-events: none;
}

/* ============================================================
   HOVER EFFECT
   ============================================================ */
.category-collapse:hover {
  box-shadow: 0 4px 14px rgba(136, 182, 242, 0.25);
}

.category-collapse:hover::before {
  background: #88b6f2;
}

/* ============================================================
   HEADER
   ============================================================ */
.category-collapse-header {
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 20px 12px 24px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  position: relative;
  z-index: 1;
}

/* ============================================================
   TITLE
   ============================================================ */
.category-collapse-title {
  flex: 1 1 auto;
  min-width: 0;
}

.category-collapse-title h5 {
  margin: 0;
  font-size: 17px;
  font-weight: 750;
  color: var(--navy);
}

.category-collapse-icon {
  width: 32px;
  height: 32px;
  min-width: 32px;
  padding: 0;
  border: 0;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--muted);
  cursor: pointer;
  transition: color 150ms ease, background 150ms ease;
}

.category-collapse-icon:hover {
  background: transparent;
  border-color: transparent;
  color: #88b6f2;
}

.category-collapse-icon svg {
  transition: transform 0.28s ease;
}

.category-collapse.open .category-collapse-icon svg {
  transform: rotate(0deg);
}

.category-collapse:not(.open) .category-collapse-icon svg {
  transform: rotate(-90deg);
}

.category-collapse-content {
  display: grid;
  grid-template-rows: 1fr;
  opacity: 1;
  overflow: hidden;
  transition: grid-template-rows 0.28s ease, opacity 0.22s ease;
}

.category-collapse.open .category-collapse-content {
  grid-template-rows: 1fr;
  opacity: 1;
}

.category-collapse:not(.open) .category-collapse-content {
  grid-template-rows: 0fr;
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
}

.category-collapse-content > .card-body {
  min-height: 0;
  overflow: hidden;
}

.category-collapse-content .row {
  min-width: 0;
}

@media (max-width: 760px) {
  .category-collapse-header {
    min-height: 60px;
    padding: 12px 14px 12px 20px;
  }
  .category-collapse-title h5 {
    font-size: 16px;
  }
}
@media (max-width: 520px) {
  .category-collapse-header {
    min-height: 56px;
    padding: 10px 11px 10px 18px;
  }
  .category-collapse-title h5 {
    font-size: 15px;
  }
  .category-collapse-icon {
    width: 30px;
    height: 30px;
    min-width: 30px;
  }
}
@media (max-width: 360px) {
  .category-collapse-header {
    padding-left: 14px;
    padding-right: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/hr_app/HomeIntro/homeIntro.scss"],"names":[],"mappings":"AAAA;EAEE,aAAA,EAAA,qBAAA;EACA,yBAAA,EAAA,qBAAA;EACA,sBAAA,EAAA,sBAAA;EACA,kBAAA,EAAA,oBAAA;EACA,YAAA;EACA,gBAAA;AAAF;;AAGA;EACE,WAAA,EAAA,2CAAA;EACA,YAAA,EAAA,wBAAA;EACA,iBAAA,EAAA,yDAAA;EACA,kBAAA;AAAF;;AAGA;;iEAAA;AAIA;EACE,kBAAA;EAEA,iCAAA;EAEA,gBAAA;EAEA,YAAA;EAEA,uCAAA;EACA,mBAAA;EAEA,uDACE;AAPJ;;AAWA;;iEAAA;AAIA;EACE,WAAA;EAEA,kBAAA;EAEA,MAAA;EACA,SAAA;EACA,OAAA;EAEA,UAAA;EAEA,mBAAA;EAEA;oDAAA;EAEA,4BAAA;EAEA,UAAA;EAEA,oBAAA;AAhBF;;AAmBA;;iEAAA;AAIA;EACE,gDAAA;AAjBF;;AAoBA;EACE,mBAAA;AAjBF;;AAoBA;;iEAAA;AAIA;EACE,gBAAA;EAEA,aAAA;EAEA,mBAAA;EAEA,8BAAA;EAEA,SAAA;EAEA,4BAAA;EAEA,eAAA;EAEA,yBAAA;UAAA,iBAAA;EAEA,kBAAA;EAEA,UAAA;AA3BF;;AA8BA;;iEAAA;AAIA;EACE,cAAA;EAEA,YAAA;AA7BF;;AAgCA;EACE,SAAA;EAEA,eAAA;EAEA,gBAAA;EAEA,kBAAA;AAhCF;;AAmCA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,mDACE;AAjCJ;;AAqCA;EACE,uBAAA;EACA,yBAAA;EACA,cAAA;AAlCF;;AAoCA;EACE,gCAAA;AAjCF;;AAmCA;EACE,uBAAA;AAhCF;;AAkCA;EACE,yBAAA;AA/BF;;AAiCA;EACE,aAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;EACA,6DACE;AA/BJ;;AAkCA;EACE,uBAAA;EACA,UAAA;AA/BF;;AAkCA;EACE,uBAAA;EACA,UAAA;EACA,oBAAA;EACA,kBAAA;AA/BF;;AAiCA;EACE,aAAA;EACA,gBAAA;AA9BF;;AAgCA;EACE,YAAA;AA7BF;;AA+BA;EACE;IACE,gBAAA;IACA,4BAAA;EA5BF;EA8BA;IACE,eAAA;EA5BF;AACF;AA8BA;EACE;IACE,gBAAA;IACA,4BAAA;EA5BF;EA8BA;IACE,eAAA;EA5BF;EA8BA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EA5BF;AACF;AA8BA;EACE;IACE,kBAAA;IACA,kBAAA;EA5BF;AACF","sourcesContent":[".image-box {\n  // width: 180px; /* Set fixed width */\n  height: 180px; /* Set fixed height */\n  background-color: #ffffff; /* White background */\n  border: 1px solid #ddd; /* Light grey border */\n  border-radius: 8px; /* Rounded corners */\n  padding: 8px;\n  overflow: hidden;\n}\n\n.image-box img {\n  width: 100%; /* Make sure the image fits the container */\n  height: 100%; /* Maintain the height */\n  object-fit: cover; /* Ensure image covers the container without distortion */\n  border-radius: 4px;\n}\n\n/* ============================================================\n   CATEGORY COLLAPSE\n   ============================================================ */\n\n.category-collapse {\n  position: relative;\n\n  border-radius: var(--radius, 8px);\n\n  overflow: hidden;\n\n  min-width: 0;\n\n  /* Keep original component background */\n  background: inherit;\n\n  transition:\n    box-shadow 150ms ease,\n    transform 150ms ease;\n}\n\n/* ============================================================\n   LEFT BLUE ACCENT\n   ============================================================ */\n\n.category-collapse::before {\n  content: \"\";\n\n  position: absolute;\n\n  top: 0;\n  bottom: 0;\n  left: 0;\n\n  width: 6px;\n\n  background: #88b6f2;\n\n  /* Hardcoded fallback radius so the curve is ALWAYS visible,\n     even if --radius is 0/undefined in this scope */\n  border-radius: 10px 0 0 10px;\n\n  z-index: 2;\n\n  pointer-events: none;\n}\n\n/* ============================================================\n   HOVER EFFECT\n   ============================================================ */\n\n.category-collapse:hover {\n  box-shadow: 0 4px 14px rgba(136, 182, 242, 0.25);\n}\n\n.category-collapse:hover::before {\n  background: #88b6f2;\n}\n\n/* ============================================================\n   HEADER\n   ============================================================ */\n\n.category-collapse-header {\n  min-height: 60px;\n\n  display: flex;\n\n  align-items: center;\n\n  justify-content: space-between;\n\n  gap: 12px;\n\n  padding: 12px 20px 12px 24px;\n\n  cursor: pointer;\n\n  user-select: none;\n\n  position: relative;\n\n  z-index: 1;\n}\n\n/* ============================================================\n   TITLE\n   ============================================================ */\n\n.category-collapse-title {\n  flex: 1 1 auto;\n\n  min-width: 0;\n}\n\n.category-collapse-title h5 {\n  margin: 0;\n\n  font-size: 17px;\n\n  font-weight: 750;\n\n  color: var(--navy);\n}\n\n.category-collapse-icon {\n  width: 32px;\n  height: 32px;\n  min-width: 32px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--muted);\n  cursor: pointer;\n  transition:\n    color 150ms ease,\n    background 150ms ease;\n}\n\n.category-collapse-icon:hover {\n  background: transparent;\n  border-color: transparent;\n  color: #88b6f2;\n}\n.category-collapse-icon svg {\n  transition: transform 0.28s ease;\n}\n.category-collapse.open .category-collapse-icon svg {\n  transform: rotate(0deg);\n}\n.category-collapse:not(.open) .category-collapse-icon svg {\n  transform: rotate(-90deg);\n}\n.category-collapse-content {\n  display: grid;\n  grid-template-rows: 1fr;\n  opacity: 1;\n  overflow: hidden;\n  transition:\n    grid-template-rows 0.28s ease,\n    opacity 0.22s ease;\n}\n.category-collapse.open .category-collapse-content {\n  grid-template-rows: 1fr;\n  opacity: 1;\n}\n\n.category-collapse:not(.open) .category-collapse-content {\n  grid-template-rows: 0fr;\n  opacity: 0;\n  pointer-events: none;\n  visibility: hidden;\n}\n.category-collapse-content > .card-body {\n  min-height: 0;\n  overflow: hidden;\n}\n.category-collapse-content .row {\n  min-width: 0;\n}\n@media (max-width: 760px) {\n  .category-collapse-header {\n    min-height: 60px;\n    padding: 12px 14px 12px 20px;\n  }\n  .category-collapse-title h5 {\n    font-size: 16px;\n  }\n}\n@media (max-width: 520px) {\n  .category-collapse-header {\n    min-height: 56px;\n    padding: 10px 11px 10px 18px;\n  }\n  .category-collapse-title h5 {\n    font-size: 15px;\n  }\n  .category-collapse-icon {\n    width: 30px;\n    height: 30px;\n    min-width: 30px;\n  }\n}\n@media (max-width: 360px) {\n  .category-collapse-header {\n    padding-left: 14px;\n    padding-right: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
